import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "social-media-xing",
  "use": "social-media-xing-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\" id=\"social-media-xing\"><path d=\"M170 0H30A30.09 30.09 0 000 30v140a30.09 30.09 0 0030 30h140a30.09 30.09 0 0030-30V30a30.09 30.09 0 00-30-30zm-55.15 137.86L100 114l-14.78 23.86H68.5l23.74-36.62-22.74-35.1h16.72L100 89.33l13.84-23.19h16.72l-23.49 35.1 24.43 36.62z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol